import { RouteInfo } from "./sidebar.metadata";

// 1 : 관리자
// 100 : 관리자(업체)   // 서울우유 대표 계정 (모든 권한)
// 300 : 운영자(업체)   // 서울우유 운영 계정 (차량,단말,계정,그룹 관리)
// 300 : 운영자(그룹)   // 서울우유 하위그룹의 운영 계정 (??)
// 1000 : 운전자        // 서울우유 운전자 계정
// 99999 : 일반사용자   // 미정
// if(limitLevel > userGroupId) ==> show menu
export const ROUTES: RouteInfo[] = [
    {
        id: 0,
        path: "/dtg/analytics/dashboard"
        ,title: "대시보드"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-02"
        ,limitLevel: 300
        ,submenu: []
    }
    ,{
        id: 0,
        path: "#"
        ,title: "차량별운행일지"
        ,icon: "mdi mdi-dots-vertical"
        ,class: "has-arrow"
        ,extralink: false
        ,pMenuId: "menu-02"
        ,limitLevel: 300
        ,submenu: [
            {
                id: 0,
                path: "/dtg/report/car/all"
                ,title: "일별 운행일지"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: ""
                ,extralink: false
                ,pMenuId: "menu-02"
                ,limitLevel: 300
                ,submenu: []
            }
            ,{
                id: 0,
                path: "/dtg/report/car/month/main"
                ,title: "월별 운행일지"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: ""
                ,extralink: false
                ,pMenuId: "menu-02"
                ,limitLevel: 300
                ,submenu: []
            }
            ,{
                id: 0,
                path: "/dtg/report/car/temper/main"
                ,title: "온도기록일지"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: ""
                ,extralink: false
                ,pMenuId: "menu-02"
                ,limitLevel: 300
                ,submenu: []
            }
            ,{
                id: 0,
                path: "/dtg/report/car/detail"
                ,title: "일별 운행일지 상세"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: "d-none"
                ,extralink: false
                ,pMenuId: "menu-02"
                ,limitLevel: 300
                ,submenu: []
            }
            ,{
                id: 0,
                path: "/dtg/report/car/month/daily"
                ,title: "월별 운행일지 상세"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: "d-none"
                ,extralink: false
                ,pMenuId: "menu-02"
                ,limitLevel: 300
                ,submenu: []
            }
            ,{
                id: 0,
                path: "/dtg/report/car/temper/daily"
                ,title: "온도기록일지 일별"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: "d-none"
                ,extralink: false
                ,pMenuId: "menu-02"
                ,limitLevel: 300
                ,submenu: []
            }
            ,{
                id: 0,
                path: "/dtg/report/car/temper/detail"
                ,title: "온도기록일지 상세"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: "d-none"
                ,extralink: false
                ,pMenuId: "menu-02"
                ,limitLevel: 300
                ,submenu: []
            }
        ]
    }
    ,{
        id: 0,
        path: "#"
        ,title: "휴게시간"
        ,icon: "mdi mdi-dots-vertical"
        ,class: "has-arrow"
        ,extralink: false
        ,pMenuId: "menu-02"
        ,limitLevel: 300
        ,submenu: [
            {
                id: 0,
                path: "/dtg/report/rest/day/schedule"
                ,title: "일반휴게시간"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: ""
                ,extralink: false
                ,pMenuId: "menu-02"
                ,limitLevel: 300
                ,submenu: []
            }
            ,{
                id: 0,
                path: "/dtg/report/rest/day/schedule"
                ,title: "지정위치휴게시간"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: ""
                ,extralink: false
                ,pMenuId: "menu-02"
                ,limitLevel: 300
                ,submenu: []
            }
        ]
    }
    ,{
        id: 1000,
        path: "#"
        ,title: "New 휴게시간"
        ,icon: "mdi mdi-dots-vertical"
        ,class: "has-arrow"
        ,extralink: false
        ,pMenuId: "menu-02"
        ,limitLevel: 300
        ,submenu: [
            {
                id: 1001,
                path: "dtg/report/rest/drive/schedule/all"
                ,title: "일반휴게시간"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: ""
                ,extralink: false
                ,pMenuId: "menu-02"
                ,limitLevel: 300
                ,submenu: []
            }
        ]
    }
    ,{
        id: 0,
        path: "/dtg/report/danger/day/main"
        ,title: "위험운전이력"
        ,icon: "mdi mdi-crown"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-02"
        ,limitLevel: 1
        ,submenu: []
    }
    // ,{
    //     path: "/dtg/report/user/all"
    //     ,title: "운전자별운행일지"
    //     ,icon: "mdi mdi-dots-vertical"
    //     ,class: ""
    //     ,extralink: false
    //     ,pMenuId: "2"
    //     ,limitLevel: 300
    //     ,submenu: []
    // }

    ,{
        id: 0,
        path: "/dtg/analytics/drive/safe/summary"
        ,title: "안전운전요약"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-03"
        ,limitLevel: 300
        ,submenu: []
    }
    // ,{
    //     path: "/dtg/analytics/drive/safe/eco"
    //     ,title: "경제운전"
    //     ,icon: "mdi mdi-dots-vertical"
    //     ,class: ""
    //     ,extralink: false
    //     ,pMenuId: "3"
    //     ,limitLevel: 300
    //     ,submenu: []
    // }
    ,{
        id: 0,
        path: "/dtg/analytics/drive/safe/safety"
        ,title: "안전운전"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-03"
        ,limitLevel: 300
        ,submenu: []
    }
    ,{
        id: 0,
        path: "/dtg/report/geofence/his/main"
        ,title: "지오펜스출입이력"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-03"
        ,limitLevel: 300
        ,submenu: []
    }
    // ,{
    //     path: "/dtg/analytics/drive/safe"
    //     ,title: "휴게시간종합"
    //     ,icon: "mdi mdi-dots-vertical"
    //     ,class: ""
    //     ,extralink: false
    //     ,pMenuId: "3"
    //     ,submenu: []
    // }
    // ,{
    //     path: "/dtg/download/calendar"
    //     ,title: "제출파일 다운로드"
    //     ,icon: "mdi mdi-dots-vertical"
    //     ,class: ""
    //     ,extralink: false
    //     ,pMenuId: "3"
    //     ,limitLevel: 300
    //     ,submenu: []
    // }
    ,{
        id: 0,
        path: "/dtg/download/etas/request"
        ,title: "제출파일 다운로드"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-03"
        ,limitLevel: 300
        ,submenu: []
    }
    ,{
        id: 0,
        path: "/dtg/analytics/drive/danger/stophighrpm/main"
        ,title: "공회전+고RPM"
        ,icon: "mdi mdi-crown"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-03"
        ,limitLevel: 1
        ,submenu: []
    }
    ,{
        id: 0,
        path: "/dtg/analytics/drive/carbon/main"
        ,title: "탄소배출량"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-03"
        ,limitLevel: 300
        ,submenu: []
    }
    ,{
        id: 0,
        path: "/dtg/manage/main"
        ,title: "환경설정안내"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-04"
        ,limitLevel: 300
        ,submenu: []
    }
    ,{
        id: 0,
        path: "/dtg/manage/company/main"
        ,title: "회사정보관리"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-04"
        ,limitLevel: 300
        ,submenu: []
    }
    ,{
        id: 0,
        path: "/dtg/manage/team/main"
        ,title: "그룹관리"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-04"
        ,limitLevel: 200
        ,submenu: []
    }
    ,{
        id: 0,
        path: "#"
        ,title: "차량관리"
        ,icon: "mdi mdi-dots-vertical"
        ,class: "has-arrow"
        ,extralink: false
        ,pMenuId: "menu-04"
        ,limitLevel: 300
        ,submenu: [
            {
                id: 0,
                path: "/dtg/manage/car/main"
                ,title: "소속차량관리"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: ""
                ,extralink: false
                ,pMenuId: "menu-04"
                ,limitLevel: 300
                ,submenu: []
            }
            ,{
                id: 0,
                path: "/dtg/manage/car/ext/main"
                ,title: "공급차량관리"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: ""
                ,extralink: false
                ,pMenuId: "menu-04"
                ,limitLevel: 300
                ,submenu: []
            }
        ]
    }
    ,{
        id: 0,
        path: "/dtg/manage/user/main"
        ,title: "사용자관리"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-04"
        ,limitLevel: 200
        ,submenu: []
    }
    ,{
        id: 0,
        path: "/dtg/manage/driver/main"
        ,title: "운전자관리"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-04"
        ,limitLevel: 300
        ,submenu: []
    }
    ,{
        id: 0,
        path: "#"
        ,title: "지오펜스관리"
        ,icon: "mdi mdi-dots-vertical"
        ,class: "has-arrow"
        ,extralink: false
        ,pMenuId: "menu-04"
        ,limitLevel: 300
        ,submenu: [
            {
                id: 0,
                path: "/dtg/manage/geofence/conf/main"
                ,title: "지오펜스지역관리"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: ""
                ,extralink: false
                ,pMenuId: "menu-04"
                ,limitLevel: 300
                ,submenu: []
            }
            ,{
                id: 0,
                path: "/dtg/manage/geofence/car/main"
                ,title: "지오펜스차량관리"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: ""
                ,extralink: false
                ,pMenuId: "menu-04"
                ,limitLevel: 300
                ,submenu: []
            }
            // ,{
            //     path: "/dtg/manage/geofence/route/main"
            //     ,title: "지오펜스경로관리"
            //     ,icon: "mdi mdi-check-circle-outline"
            //     ,class: ""
            //     ,extralink: false
            //     ,pMenuId: "menu-04"
            //     ,limitLevel: 300
            //     ,submenu: []
            // }
        ]
    }
    ,{
        id: 0,
        path: "/dtg/manage/danger/drive/rule/main"
        ,title: "위험운전설정관리"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-04"
        ,limitLevel: 300
        ,submenu: []
    }
    ,{
        id: 0,
        path: "/dtg/manage/schedule/drive/main"
        ,title: "배차관리"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-04"
        ,limitLevel: 300
        ,submenu: []
    }
    ,{
        id: 0,
        path: "/dtg/notice/main"
        ,title: "공지사항"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-04"
        ,limitLevel: 300
        ,submenu: []
    }
    ,{
        id: 0,
        path: "/dtg/manage/etas/file/main"
        ,title: "E-Tas파일관리"
        ,icon: "mdi mdi-crown"
        ,class: "has-arrow"
        ,extralink: false
        ,pMenuId: "menu-04"
        ,limitLevel: 1
        ,submenu: [
            {
                id: 0,
                path: "/dtg/manage/etas/file/main"
                ,title: "E-Tas파일요청"
                ,icon: "mdi mdi-check-circle-outline"
                ,class: ""
                ,extralink: false
                ,pMenuId: "menu-04"
                ,limitLevel: 1
                ,submenu: []
            }
        ]
    }
    ,{
        id: 0,
        path: "/dtg/manage/notice/main"
        ,title: "공지관리"
        ,icon: "mdi mdi-crown"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-04"
        ,limitLevel: 1
        ,submenu: []
    }
    ,{
        id: 0,
        path: "/dtg/manage/etas/car/main"
        ,title: "E-Tas차량관리"
        ,icon: "mdi mdi-crown"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-04"
        ,limitLevel: 1
        ,submenu: []
    }

    // ,{
    //     path: "/dtg/manage/geofence/route/main"
    //     ,title: "지오펜스경로관리"
    //     ,icon: "mdi mdi-crown"
    //     ,class: ""
    //     ,extralink: false
    //     ,pMenuId: "menu-05"
    //     ,limitLevel: 1
    //     ,submenu: []
    // }
    ,{
        id: 0,
        path: "/dtg/packet/realtime"
        ,title: "실시간패킷확인"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-05"
        ,limitLevel: 100
        ,submenu: []
    }
    ,{
        id: 0,
        path: "/dtg/test/t01"
        ,title: "t01"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-05"
        ,limitLevel: 100
        ,submenu: []
    }
    ,{
        id: 0,
        path: "/dtg/test/t02"
        ,title: "t02"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-05"
        ,limitLevel: 100
        ,submenu: []
    }
    ,{
        id: 0,
        path: "/dtg/test/t03"
        ,title: "t03"
        ,icon: "mdi mdi-dots-vertical"
        ,class: ""
        ,extralink: false
        ,pMenuId: "menu-05"
        ,limitLevel: 100
        ,submenu: []
    }
    // ,{
    //     path: "#"
    //     ,title: "운행일지"
    //     ,icon: "mdi mdi-car-connected"
    //     ,class: "has-arrow"
    //     ,extralink: false
    //     ,submenu: [
    //         {
    //             path: "/dtg/report/car/all"
    //             ,title: "차량별"
    //             ,icon: "mdi mdi-car"
    //             ,class: ""
    //             ,extralink: false
    //             ,submenu: []
    //         }
    //         ,{
    //             path: "/dtg/report/user/all"
    //             ,title: "사용자별"
    //             ,icon: "mdi mdi-account"
    //             ,class: ""
    //             ,extralink: false
    //             ,submenu: []
    //         }
    //     ]
    // }
];
